import React from 'react';
import ReaderWrapper from '../ReaderWrapper';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    header: {
        fontWeight: '600',
    },
    downloadLink: {
        fontWeight: '500',
    },
};

class InfoReader extends React.Component {
    constructor() {
        super();
        this.state = {
            dataExe: ['Loading...'],
            updateExe: ['Loading...'],
            dataMsi: ['Loading...'],
            updateMsi: ['Loading...'],
            dataNew: ['Loading...'],
            updateNew: ['Loading...'],
        };
    }

    componentDidMount() {
        fetch('https://installer.services.cloud.signiant.com/server/?platform=windows')
            .then(async (response) => {
                return { data: await response.json() };
            })
            .then(({ data, modifiedSinceLinux }) => {
                this.setState({
                    dataExe: data.installerVersion,
                    windowsURL: data.installerURL,
                    dateWin: data.installerReleaseDate.substring(0, 10),
                });
            });

        fetch('https://installer.services.cloud.signiant.com/server/?platform=linux')
            .then(async (response) => {
                return { data: await response.json() };
            })
            .then(({ data, modifiedSinceLinux }) => {
                this.setState({
                    dataTar: data.installerVersion,
                    linuxURL: data.installerURL,
                    dateLinux: data.installerReleaseDate.substring(0, 10),
                });
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <ReaderWrapper>
                <table>
                    <thead className={classes.header}>
                        <td>Installer Type</td>
                        <td>Version</td>
                        <td>Release Date</td>
                        <td></td>
                    </thead>
                    <tr>
                        <td>Windows .exe</td>
                        <td>{this.state.dataExe}</td>
                        <td>{this.state.dateWin}</td>
                        <td>
                            <a
                                id="download-sdcx-server-windows-exe"
                                className={classes.downloadLink}
                                href={this.state.windowsURL}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Linux .tar.gz</td>
                        <td>{this.state.dataTar}</td>
                        <td>{this.state.dateLinux}</td>
                        <td>
                            <a
                                id="download-sdcx-server-linux-tar-gz"
                                className={classes.downloadLink}
                                href={this.state.linuxURL}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                </table>
            </ReaderWrapper>
        );
    }
}

export default withStyles(styles)(InfoReader);
